"use client";
import { IStyleProps } from "@/src/app/interface";
import { useCommonContext, useRateContext } from "@/src/provider";
import { getSiteConfiguration } from "@/src/utils/configUtils";
import React from "react";
import { useTranslation } from "../i18n/client";
interface IProps extends IStyleProps {}
const GetVatText: React.FC<IProps> = (props) => {
    const { host, site } = useCommonContext();
    const { t } = useTranslation("common");

    const [getPrice] = useRateContext((state) => [state.getPrice]);
    return (
        ["us", "fm"].includes(site) && (
            <span
                style={{
                    fontSize: "0.24rem",
                    color: "#333",
                    textAlign: "left",
                    ...props.style,
                }}
                className={props.className}
            >
                {t("common:VAT.Notice_1")}
                {getSiteConfiguration("seoSite", host)}
                {t("common:VAT.Notice_1_1")}
                <span
                    style={{
                        color: "red",
                        margin: "0 5px",
                        fontFamily: "var(--font-montserrat-medium)",
                    }}
                >
                    <span
                        dangerouslySetInnerHTML={{ __html: `${getPrice(7)}` }}
                    ></span>{" "}
                    VAT
                </span>
                {t("common:VAT.Notice_2")}
            </span>
        )
    );
};

export default GetVatText;
